import { cn } from '@/lib/utils';
import { SEG_BTN, SEG_TRILHO } from './TriagemShell';

/* Quem trabalha como BKO Contrato pela função adicional (a supervisora) abre a
   fila nos pedidos dela e vê todos quando quiser (Douglas 28/10/2026). */
export function SoOsMeusToggle({ soOsMeus, onChange }: { soOsMeus: boolean; onChange: (v: boolean) => void }) {
  return (
    <span className={SEG_TRILHO}>
      {([[true, 'Os meus'], [false, 'Todos']] as const).map(([valor, rotulo]) => {
        const ligado = soOsMeus === valor;
        return (
          <button
            key={rotulo}
            type="button"
            onClick={() => onChange(valor)}
            title={valor ? 'Só os pedidos que são seus e os sem dono' : 'A fila inteira, de todas as BKOs'}
            className={cn(SEG_BTN, ligado ? 'bg-white text-primary' : 'text-white/60 hover:text-white')}
          >
            {rotulo}
          </button>
        );
      })}
    </span>
  );
}
